import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { SearchArea } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { getStoreLocationsAsync } from '../generated/DataActionExtension.g';
import { IDXC_StoreLocationsResponse } from '../generated/DataServiceEntities.g';

// tslint:disable-next-line: completed-docs
export class GetStoreLocationsInput implements IActionInput {
    public searchCriteria: SearchArea;
    constructor(searchKey: SearchArea) {
        this.searchCriteria = searchKey;
    }

    public getCacheKey = () => 'StoreLocations';
    public getCacheObjectType = () => 'StoreLocations';
    public dataCacheType = (): CacheType => 'request';
}

export function createGetStoreLocationsInput(inputData: ICreateActionContext<IGeneric<IAny>>,
                                             searchKey: { Longitude?: number; Latitude?: number; Radius?: number; DistanceUnitValue?: number }): IActionInput {
    return new GetStoreLocationsInput(searchKey);
}

export async function getStoreLocationsAction(
    input: GetStoreLocationsInput,
    ctx: IActionContext
): Promise<IDXC_StoreLocationsResponse> {
    let storesResult: IDXC_StoreLocationsResponse = { success: false };
    return getStoreLocationsAsync({ callerContext: ctx }, input.searchCriteria)
        .then((response) => {
            if (response && !(response instanceof Error)) {
                storesResult = response;
                return storesResult;
            } else {
                return storesResult;
            }
        })
        .catch((error: Error) => {
            ctx.trace('[getStoreLocationsAsync] error getting Available Inventory Nearby');
            ctx.trace(error.message);
            return storesResult;
        });
}

export const ISubmitContactFormDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_StoreLocationsResponse>>getStoreLocationsAction,
    input: createGetStoreLocationsInput
});